module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 1010 173.4\" style=\"enable-background:new 0 0 1010 173.4;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{opacity:0.15;fill:#30A4CD;enable-background:new ;} .st1{font-family:&#x27;FrankRuhlLibre-Regular&#x27;;} .st2{font-size:155px;} .st3{letter-spacing:9;} </style><text transform=\"matrix(1 0 0 1 0 128.6504)\" class=\"st0 st1 st2 st3\">Comfort Care</text></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/comfort-care-lvo.svg
// module id = 513
// module chunks = 1